// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/nav_dot_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/nav_bar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1300px) {
  /* REPORTS_RESPONSIVE_CSS_START */
  .report_name_outer {
    order: 1;
    width: 100%;
  }
  .Reports_top_button_div {
    width: 100%;
    order: 2;
  }
  .reports_top_right_div {
    width: 100%;
    order: 3;
  }
  .reports_top_header {
    flex-direction: column;
    row-gap: 20px;
  }
  .reports_top_right_div,
  .Reports_top_button_div ul {
    justify-content: center;
  }
}

@media (max-width: 1199px) {
  /* REPORTS_RESPONSIVE_CSS_START */
  .main-content-wrapper-reports .reports_pdf_nav_tab {
    width: 100%;
    height: auto;
  }
  .main-content-wrapper-reports .reports_pdf_nav_tab ul li {
    padding: 5px 20px;
    margin-bottom: 0px;
    width: 100%;
    max-width: 85px;
    min-width: 85px;
  }
  .main-content-wrapper-reports .reports_pdf_nav_tab ul {
    display: flex;
    display: -webkit-flex;
    margin: 0px;
    padding: 15px 0px;
  }
}

@media (max-width: 1024px) {
}

@media (max-width: 991px) {
  .select_client_outer {
    margin-top: 10px;
    width: 100%;
    float: none;
  }
  .navbar-right-top {
    row-gap: 15px;
    padding: 20px 0px 30px;
  }
  .nav-left-sidebar .container-fluid {
    padding: 0px;
  }
  .navbar-right-top .nav-item:first-child {
    border-right: 0px solid #e6e6f2;
  }
  .Mobile_user_client_details {
    display: block;
  }
  .main-header .navbar-light .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    filter: invert(1);
  }
  .nav-left-sidebar .navbar-light .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    filter: invert(1);
  }
  .Expenses_div_main_otr {
    padding-right: 15px;
  }

  /* REPORTS_RESPONSIVE_CSS_START */
  .main-content-wrapper-reports {
    display: flex;
    display: -webkit-flex;
    margin-left: 0;
    flex-direction: column;
  }
  .main-content-wrapper-reports .reports_pdf_nav_tab {
    position: unset;
  }
  .reports_pdf_page_count {
    flex-direction: column;
    row-gap: 20px;
    text-align: center;
  }
  .reports_pdf_footer_outer {
    flex-direction: column;
    row-gap: 20px;
  }
  .reports_pdf_footer_outer {
    padding: 15px 15px;
  }
  .reports_pdf_outer .reports_pdf_header_outer {
    flex-direction: column;
    row-gap: 20px;
  }
  .reports_pdf_outer .reports_pdf_financial_advisors,
  .reports_pdf_outer .reports_client_name_outer,
  .reports_pdf_outer .reports_advisor_name_date {
    width: 100%;
    text-align: center;
  }
  .Reports_top_button_div ul {
    flex-wrap: wrap;
    row-gap: 7px;
  }
  .reports_advisor_comments_outer {
    padding: 0px;
  }
}

@media (max-width: 840px) {
}

@media (max-width: 768px) {
  .h-100 {
    height: auto !important;
  }
}

@media (max-width: 767px) {
  .market_forecast_box .box_title {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .amounts_main_outer {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .market_forecast_box .box_item {
    padding: 6px 2px 6px;
  }
}

@media (max-width: 576px) {
  .amounts_main_outer {
    grid-template-columns: 1fr 1fr;
  }
  .client_contact_recency_inner .Under_Management_content_left {
    width: 25%;
    float: left;
  }
  .client_contact_recency_inner
    .Under_Management
    .Under_Management_content_right {
    text-align: left;
    width: 25%;
    float: left;
  }
  .Under_Management .Under_Management_image {
    margin-bottom: 20px;
  }
}

@media (max-width: 420px) {
  .select_client_outer .select_client_outer_form_row {
    flex-direction: column;
    row-gap: 10px;
  }
  .select_client_outer .select2-container {
    width: 100% !important;
  }
  .select_client_outer
    .select_client_outer_form_row
    .date_picker
    input.form-control {
    width: 100%;
  }
}

@media (max-width: 375px) {
  .market_forecast_box .box_item {
    width: 100%;
  }
  .amounts_main_outer {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 360px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/greenrWebsite/responsive.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,WAAW;IACX,QAAQ;EACV;EACA;IACE,WAAW;IACX,QAAQ;EACV;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;;IAEE,uBAAuB;EACzB;AACF;;AAEA;EACE,iCAAiC;EACjC;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;EACjB;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;AACA;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;EACA;IACE,+BAA+B;EACjC;EACA;IACE,cAAc;EAChB;EACA;IACE,yDAAsD;IACtD,iBAAiB;EACnB;EACA;IACE,yDAAiD;IACjD,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;;EAEA,iCAAiC;EACjC;IACE,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;;;IAGE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;AACA;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;;;IAGE,gBAAgB;IAChB,UAAU;IACV,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;;;;IAIE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;AACA","sourcesContent":["@media (max-width: 1300px) {\r\n  /* REPORTS_RESPONSIVE_CSS_START */\r\n  .report_name_outer {\r\n    order: 1;\r\n    width: 100%;\r\n  }\r\n  .Reports_top_button_div {\r\n    width: 100%;\r\n    order: 2;\r\n  }\r\n  .reports_top_right_div {\r\n    width: 100%;\r\n    order: 3;\r\n  }\r\n  .reports_top_header {\r\n    flex-direction: column;\r\n    row-gap: 20px;\r\n  }\r\n  .reports_top_right_div,\r\n  .Reports_top_button_div ul {\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n@media (max-width: 1199px) {\r\n  /* REPORTS_RESPONSIVE_CSS_START */\r\n  .main-content-wrapper-reports .reports_pdf_nav_tab {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n  .main-content-wrapper-reports .reports_pdf_nav_tab ul li {\r\n    padding: 5px 20px;\r\n    margin-bottom: 0px;\r\n    width: 100%;\r\n    max-width: 85px;\r\n    min-width: 85px;\r\n  }\r\n  .main-content-wrapper-reports .reports_pdf_nav_tab ul {\r\n    display: flex;\r\n    display: -webkit-flex;\r\n    margin: 0px;\r\n    padding: 15px 0px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .select_client_outer {\r\n    margin-top: 10px;\r\n    width: 100%;\r\n    float: none;\r\n  }\r\n  .navbar-right-top {\r\n    row-gap: 15px;\r\n    padding: 20px 0px 30px;\r\n  }\r\n  .nav-left-sidebar .container-fluid {\r\n    padding: 0px;\r\n  }\r\n  .navbar-right-top .nav-item:first-child {\r\n    border-right: 0px solid #e6e6f2;\r\n  }\r\n  .Mobile_user_client_details {\r\n    display: block;\r\n  }\r\n  .main-header .navbar-light .navbar-toggler-icon {\r\n    background-image: url('../../images/nav_dot_icon.svg');\r\n    filter: invert(1);\r\n  }\r\n  .nav-left-sidebar .navbar-light .navbar-toggler-icon {\r\n    background-image: url('../../images/nav_bar.svg');\r\n    filter: invert(1);\r\n  }\r\n  .Expenses_div_main_otr {\r\n    padding-right: 15px;\r\n  }\r\n\r\n  /* REPORTS_RESPONSIVE_CSS_START */\r\n  .main-content-wrapper-reports {\r\n    display: flex;\r\n    display: -webkit-flex;\r\n    margin-left: 0;\r\n    flex-direction: column;\r\n  }\r\n  .main-content-wrapper-reports .reports_pdf_nav_tab {\r\n    position: unset;\r\n  }\r\n  .reports_pdf_page_count {\r\n    flex-direction: column;\r\n    row-gap: 20px;\r\n    text-align: center;\r\n  }\r\n  .reports_pdf_footer_outer {\r\n    flex-direction: column;\r\n    row-gap: 20px;\r\n  }\r\n  .reports_pdf_footer_outer {\r\n    padding: 15px 15px;\r\n  }\r\n  .reports_pdf_outer .reports_pdf_header_outer {\r\n    flex-direction: column;\r\n    row-gap: 20px;\r\n  }\r\n  .reports_pdf_outer .reports_pdf_financial_advisors,\r\n  .reports_pdf_outer .reports_client_name_outer,\r\n  .reports_pdf_outer .reports_advisor_name_date {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n  .Reports_top_button_div ul {\r\n    flex-wrap: wrap;\r\n    row-gap: 7px;\r\n  }\r\n  .reports_advisor_comments_outer {\r\n    padding: 0px;\r\n  }\r\n}\r\n\r\n@media (max-width: 840px) {\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .h-100 {\r\n    height: auto !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .market_forecast_box .box_title {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .amounts_main_outer {\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n  }\r\n  .market_forecast_box .box_item {\r\n    padding: 6px 2px 6px;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .amounts_main_outer {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n  .client_contact_recency_inner .Under_Management_content_left {\r\n    width: 25%;\r\n    float: left;\r\n  }\r\n  .client_contact_recency_inner\r\n    .Under_Management\r\n    .Under_Management_content_right {\r\n    text-align: left;\r\n    width: 25%;\r\n    float: left;\r\n  }\r\n  .Under_Management .Under_Management_image {\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 420px) {\r\n  .select_client_outer .select_client_outer_form_row {\r\n    flex-direction: column;\r\n    row-gap: 10px;\r\n  }\r\n  .select_client_outer .select2-container {\r\n    width: 100% !important;\r\n  }\r\n  .select_client_outer\r\n    .select_client_outer_form_row\r\n    .date_picker\r\n    input.form-control {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 375px) {\r\n  .market_forecast_box .box_item {\r\n    width: 100%;\r\n  }\r\n  .amounts_main_outer {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
